export function is401(res) {
  return res && res.status === 9
}

// 与后端沟通确认了，原 404 状态码，现在返回空对象或空数组
export function is404(res) {
  const resString = JSON.stringify(res)
  return resString === '{}' || resString === '[]'
}

export function isErrorStatus(res) {
  return is404(res) || is401(res)
}
